import { Fragment, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/private-notices/PrivateNoticesAction";
import { downloadErrorAlert, NoticeReceipentType, redirectToPages, saveAsFile } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { TeachersPage } from "./receipent-teachers/TeachersPage";
import { ParentsPage } from "./receipent-parents/ParentsPage";
import { StudentsPage } from "./receipent-students/StudentsPage";
import { SectionsPage } from "./receipent-sections/SectionsPage";

export function PrivateNoticeDetail({
  match: {
    params: { id }
  }
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  
  // Getting curret state of Private Notice Details from store (Redux)
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, privateNotice } = useSelector(
    (state) => ({
      actionsLoading: state.privateNotices.actionsLoading,
      isSuccess: state.privateNotices.isSuccess,
      type: state.privateNotices.type,
      privateNotice: state.privateNotices.privateNotice
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getPrivateNotice(id));
    return () => dispatch(actions.cleanPrivateNoticesState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Özel Duyuru Detayı";
    setTitle(_title);
    subheader.setTitle(_title);
  }, [subheader]);
    
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  /** Belli Bir Eki İndirir */
  const downloadAttachment = () => {
    dispatch(actions.downloadAttachment(id)).then(file => {
      if (!file) {
        downloadErrorAlert();
        return;
      }
      saveAsFile(file, privateNotice.attachmentName);
  })}

  const expArr = privateNotice.explanation.split("\n");

  return (
    <>
      <Card>
        { actionsLoading && <ModalProgressBar /> }
        <CardHeader title={title} />
          <CardBody>
          <div className="form-group row">
            <div className="col-2">
              <b>Gönderen:</b>
            </div>
            <div className="col-10">
              {privateNotice.sender}
            </div>            
          </div>

          <div className="form-group row">
            <div className="col-2">
              <b>Tarih:</b>
            </div>
            <div className="col-10">
              {privateNotice.createDate}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2">
              <b>Tanımı:</b>
            </div>
            <div className="col-10">
              {privateNotice.definition}
            </div>
          </div>
          
          <div className="form-group row">
            <div className="col-2">
              <b>Açıklaması:</b>
            </div>
            <div className="col-10">
              {
                expArr.map((explanation, i) => (
                  <Fragment key={i}>
                    {explanation}
                    {i !== expArr.length - 1 && <br />}
                  </Fragment>
                ))
              }
            </div>
          </div>
          {
            privateNotice.attachmentName &&
            <div className="form-group row">
              <div className="col-2">
                <b>Ek:</b>
              </div>
              <div className="col-10">
                <a href="javascript:" onClick={downloadAttachment}>{privateNotice.attachmentName}</a>
              </div>
            </div>
          }
          <div className="form-group row">
            <div className="col-2">
              <b>Gönderim Türü:</b>
            </div>
            <div className="col-10">
              {privateNotice.sendingType}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2">
              <b>Durum:</b>
            </div>
            <div className="col-10">
              {
                privateNotice.isSent !== undefined &&
                <span className={`label label-lg label-light-${privateNotice.isSent ? "success" : "danger"} label-inline`}>{privateNotice.isSent ? "Gönderildi" : "Beklemede"}</span>
              }
            </div>
          </div>
        </CardBody>
      </Card>
      {
        privateNotice.receipentType === NoticeReceipentType.Teacher &&
        <TeachersPage
          noticeId={id}
        />
      }
      {
        (privateNotice.receipentType === NoticeReceipentType.Parent || privateNotice.receipentType === NoticeReceipentType.Father || privateNotice.receipentType === NoticeReceipentType.Mother) &&
        <ParentsPage
          receipentType={privateNotice.receipentType}
          noticeId={id}
        />
      }
      {
        (privateNotice.receipentType === NoticeReceipentType.Student  || privateNotice.receipentType === NoticeReceipentType.AdvisorStudent) &&
        <StudentsPage
          receipentType={privateNotice.receipentType}
          noticeId={id}
        />
      }
      {
        privateNotice.receipentType === NoticeReceipentType.Section &&
        <SectionsPage
          noticeId={id}
        />
      }
    </>    
  );
}